<template>
  <div id="app">
    <loading :active.sync="preloaderStatus" color="#39833c" :is-full-page="true"></loading>
    <confirm></confirm>
    <div class="indent" :style="{height: header_height + 'px'}"></div>
    <div class="wrapper">
      <router-view v-if="$route.meta.hideHeader"/>

      <template v-if="!$route.meta.hideHeader">
        <v-header ref="header"/>
        <div class="dado" :class="{'without-sidebar' : isObserver}">
          <router-view/>
        </div>
      </template>

      <v-modal></v-modal>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import Loading from 'vue-loading-overlay'
  import 'vue-loading-overlay/dist/vue-loading.css'

  export default {
    components: {Loading},
    data() {
      return {
        header_height: 76
      }
    },
    computed: {
      ...mapGetters([
        'preloaderStatus',
        'getAuthUser',
      ]),
      isObserver () {
        return this.getAuthUser.role_name ? this.getAuthUser.role_name.toLowerCase() === 'observer' : false
      }
    },
    created() {
      window.addEventListener('resize', this.onResize)
    },
    mounted() {
      this.onResize()
      setTimeout(() => {
        this.onResize()
      }, 300)
    },
    methods: {
      onResize: function () {
        if (this.$refs.header)
          this.header_height = this.$refs.header.$el.clientHeight
      }
    }
  }
</script>

<style lang="scss">
  @import url('~jquery-ui/themes/base/all.css');
  @import url('./assets/css/style.css');

  *:focus { outline: 0 }

  .cursor-pointer { cursor: pointer }

  .text_with_n {
    white-space: pre-wrap;
    word-wrap: break-word;
    font-family: inherit;
  }
  .font14 { font-size: 14px !important }
  .img50x50 { height: 50px; width: 50px; }

  // forms
  .search .form__del {
    right: 40px !important;
  }
  .popup__submit[disabled] {
    background-color: #39833Caa !important;
    color: #fff !important;
    &:hover {
      background-color: #39833Caa !important;
      color: #fff !important;
    }
  }

  // colors
  .text-warning { color: #ffc700 !important }
  .text-success { color: #39833C !important }
  .opacity50 { opacity: 0.5 }

  // modals
  #sub-modal.popup__wrapper {
    background-color: #F0F1F4aa;
    .popup { max-width: 650px; }
  }

  // table
  .col_id { width: 50px }
  .col_num { width: 100px }
  .col_manage { width: 90px }
  .table__status.draft {
    min-width: 12px;
    max-width: 12px;
    height: 12px;
    -webkit-border-radius: 50%;
    border-radius: 50%;
    background-color: #7c703e; }

  // select2 fix
  .select2-container {
    .select2-selection--single {
      height: 48px !important;
      border-radius: 2px !important;
    }
    .select2-selection__arrow b {
      height: 10px !important;
    }
    .select2-selection__rendered {
      color: #000 !important;
      line-height: 48px !important;
      padding-left: 20px !important;
      padding-right: 40px !important;
    }
    .select2-selection__arrow {
      height: 100% !important;
      top: 0 !important;
      width: 40px !important;
    }
    .select2-results__option--highlighted[aria-selected] {
      background-color: #333 !important;
    }
  }
  .select2-selection--multiple {
    .select2-selection__rendered {
      line-height: 36px !important;
    }
    .select2-search--inline .select2-search__field {
      height: 30px;
      margin-top: 8px;
    }
  }
  .select2-container--default {
    .select2-selection--single {
      .select2-selection__arrow b {
        height: 15px !important;
      }
    }
    .select2-selection--multiple {
      .select2-selection__choice {
        background-color: #e4e4e4;
        border: 1px solid #aaa;
        border-radius: 4px;
        cursor: default;
        float: left;
        margin-right: 5px;
        margin-top: 5px;
        padding: 0 5px;
      }
      .select2-search--inline {
        height: 30px;
        margin-top: 0;
        .select2-search__field {
          height: 30px;
          margin-top: 0;
        }
      }
    }
  }

  // <transition name="fade"></transition>
  .fade-enter-active, .fade-leave-active {
    transition: opacity 1s !important;
  }

  // pagination
  .pagination {
    .pagination__prev {
      padding: 0;
      margin-right: 15px;
      a {
        display: block;
        padding: 6px 20px 7px 20px;
      }
    }
    .pagination__next {
      padding: 0;
      margin-left: 15px;
      a {
        display: block;
        padding: 6px 20px 7px 20px;
      }
    }
    .pagination__item {
      a {
        display: block;
        padding: 0 5px;
      }
      &.active {
        border: 1px solid #0000;
        background-color: #39833C;
        color: #fff;
        border-radius: 2px;
      }
    }
  }

  // slick-slide
  .popup__typesetting {
    .slick-list { margin: 0 60px !important }
    .slick-slide { margin: 0 5px !important }
    .popup__language { margin: auto !important }
  }

  // datepicker
  .vdp-datepicker input {
    border: none;
    width: 100%;
  }
  .vdp-datepicker__clear-button,
  .vdp-datepicker__calendar-button {
    position: absolute;
    top: 8px;
    font-size: 22px;
    i {
      font-style: normal;
    }
  }
  .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day,
  .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month,
  .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year {
    color: #000;
  }

  // v-tooltip
  .tooltip {
    display: block !important;
    z-index: 10000;

    .tooltip-inner {
      background: black;
      color: white;
      border-radius: 16px;
      padding: 5px 10px 4px;
    }

    .tooltip-arrow {
      width: 0;
      height: 0;
      border-style: solid;
      position: absolute;
      margin: 5px;
      border-color: black;
      z-index: 1;
    }

    &[x-placement^="top"] {
      margin-bottom: 5px;

      .tooltip-arrow {
        border-width: 5px 5px 0 5px;
        border-left-color: transparent !important;
        border-right-color: transparent !important;
        border-bottom-color: transparent !important;
        bottom: -5px;
        left: calc(50% - 5px);
        margin-top: 0;
        margin-bottom: 0;
      }
    }

    &[x-placement^="bottom"] {
      margin-top: 5px;

      .tooltip-arrow {
        border-width: 0 5px 5px 5px;
        border-left-color: transparent !important;
        border-right-color: transparent !important;
        border-top-color: transparent !important;
        top: -5px;
        left: calc(50% - 5px);
        margin-top: 0;
        margin-bottom: 0;
      }
    }

    &[x-placement^="right"] {
      margin-left: 5px;

      .tooltip-arrow {
        border-width: 5px 5px 5px 0;
        border-left-color: transparent !important;
        border-top-color: transparent !important;
        border-bottom-color: transparent !important;
        left: -5px;
        top: calc(50% - 5px);
        margin-left: 0;
        margin-right: 0;
      }
    }

    &[x-placement^="left"] {
      margin-right: 5px;

      .tooltip-arrow {
        border-width: 5px 0 5px 5px;
        border-top-color: transparent !important;
        border-right-color: transparent !important;
        border-bottom-color: transparent !important;
        right: -5px;
        top: calc(50% - 5px);
        margin-left: 0;
        margin-right: 0;
      }
    }

    &.popover {
      $color: #f9f9f9;

      .popover-inner {
        background: $color;
        color: black;
        padding: 24px;
        border-radius: 5px;
        box-shadow: 0 5px 30px rgba(black, .1);
      }

      .popover-arrow {
        border-color: $color;
      }
    }

    &[aria-hidden='true'] {
      visibility: hidden;
      opacity: 0;
      transition: opacity .15s, visibility .15s;
    }

    &[aria-hidden='false'] {
      visibility: visible;
      opacity: 1;
      transition: opacity .15s;
    }

  }
  .questions__bill_text { background-color: #3b84d1 !important }
</style>
